import { ICreateIndiceReajusteUseCase } from "../../../presentation/useCases/create/create_indice_reajuste_use_case";
import { IndiceReajuste } from "../../models/indice_reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateIndiceReajusteUseCase
 */

export class CreateIndiceReajusteUseCase implements ICreateIndiceReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createIndiceReajuste(form: IndiceReajuste): Promise<number> {
    return await this.repository.createIndiceReajuste(form);

  };

}
